import { useCallback, useContext } from "react";
import ChartColorRegistryStoreContext from "../contexts/ChartColorRegistryStoreContext";

function useColorRegistry() {
  const colorRegistry = useContext(ChartColorRegistryStoreContext);

  return useCallback((id: string) => colorRegistry[id], [colorRegistry]);
}
export default useColorRegistry;
